import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import {
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  StyledTypography,
  TypographyDefault,
} from "../../Theme";
import {
  Avatar,
  Stack,
  Box,
  Grid,
  Typography,
  Divider,
  Skeleton,
  Button,
  Checkbox,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import axiosInstance from "../../Redux/AxiosInstance";
import moment from "moment";
import VisitorModal from "./VisitorModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";
import parsePhoneNumberFromString from "libphonenumber-js";

const reviewstyle = {
  minHeight: "61px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  padding: "10px 0",
};

function stringToColor(string) {
 

  // Array of colors
  const colors = ["#EBE1CE", "#009C70", "#800000", "#FEE4E2"];

  // Generate a hash based on the string to choose an index for the colors array
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to pick a color from the array (modulo operation ensures the index is within bounds)
  const colorIndex = Math.abs(hash) % colors.length;

  return colors[colorIndex];
}

function stringAvatar(name) {
  if (/\s/.test(name)) {
    return {
      sx: {
        bgcolor: stringToColor(name),
        color: stringToColor(name) === "#800000" ? "white" : "#111927",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  } else {
    return {
      sx: {
        bgcolor: stringToColor(name),
        color: stringToColor(name) === "#800000" ? "white" : "#111927",
      },
      children: `${name.split(" ")[0][0]}`,
    };
  }
}

const VisitorsDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [reasonDelete, setReasonDelete] = useState("")
  const { userDetails } = useSelector((state) => state.Login);
  const [modalLoading, setModalLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { state } = location;
  const { data } = state || {};
  const [apiData, setApiData] = useState(null);
  const [visitors, setvisitors] = useState([]);
  const [block, setblock] = useState({
    wovisitor: false,
    wvisitor: false,
    selfregister: false,
  });
  const { propertyId } = useSelector((state) => state.PropertyDetails);
  const [loading, setloading] = useState(true);
  const [visitorsList, setVisitorsList] = useState(visitors?.invited_visitor || []);
const [selectedIds, setSelectedIds] = useState([]);
const [editItem, setEditItem] = useState(null);
const [openEditModal, setOpenEditModal] = useState(false);
const [openAddModal, setOpenAddModal] = useState(false);

console.log("visitors", visitors);


const fetchVisitors = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}list_visitors_id?title_id=${id}`
    );
    const dataa = response?.data?.data[0];
    console.log("dataa", dataa);
    setvisitors(dataa);
    setloading(false);
  } catch (error) {
    console.error("Error fetching visitors:", error);
    setloading(false);
  }
};

useEffect(() => {
  fetchVisitors();
}, [id]);

useEffect(() => {
  setVisitorsList(visitors?.visitor_personal_details || []);
}, [visitors]);

const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback for unsupported browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    toast.success("QR link copied!");
  } catch (error) {
    console.error("Copy failed:", error);
    toast.error("Failed to copy!");
  }
};


const formatPhone = (number) => {
  if (!number) return "-";

  // Add + if missing
  const normalized = number.startsWith("+") ? number : `+${number}`;

  const phone = parsePhoneNumberFromString(normalized);
  return phone ? phone.formatInternational() : normalized;
};



const handleDelete = async (id) => {
  setDeleteLoading(true);
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}delete_bulk_visitors/${visitors?.id}?canceller_email=${userDetails?.email}`,
      {
        visitor_ids: [id],
        email: userDetails?.email,
        cancellation_reason : reasonDelete
      }
    );

    if (response.status === 200) {
      toast.success("Visitor deleted successfully");
      fetchVisitors();
      setReasonDelete("")
      // ⛔ CLOSE DELETE MODAL
      setOpenDeleteModal(false);
      setDeleteId(null);
    }
  } catch (error) {
    console.error("Error deleting visitor:", error);
  } finally {
    setDeleteLoading(false);
    setReasonDelete("")
  }
};

const handleMultiDelete = async () => {
  setDeleteLoading(true);
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}delete_bulk_visitors/${visitors?.id}?canceller_email=${userDetails?.email}`, {
      visitor_ids: selectedIds,
      email : userDetails?.email,
      cancellation_reason : reasonDelete
    });
    if (response.status === 200) {
      fetchVisitors()
      toast.success("Visitors deleted successfully");
      setReasonDelete("")
    }
  } catch (error) {
    toast.error("Error deleting visitors");
  } finally {
    setDeleteLoading(false);
    setSelectedIds([]);
    setReasonDelete("")
  }
};

const handleSendEmail = async (id) => {
  setDeleteLoading(true);
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}resend_email_visitors/${visitors?.id}?sender_email=${userDetails?.email}`,
      {
        visitor_ids: [id],
        email: userDetails?.email,
      }
    );

    if (response.status === 200) {
      toast.success("Email Sent successfully");
      fetchVisitors();

      // ⛔ CLOSE DELETE MODAL
      setOpenDeleteModal(false);
      setDeleteId(null);
    }
  } catch (error) {
    console.error("Error deleting visitor:", error);
  } finally {
    setDeleteLoading(false);
  }
};

const handleMultiSendEmail = async () => {
  setDeleteLoading(true);
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}resend_email_visitors/${visitors?.id}?sender_email=${userDetails?.email}`, {
      visitor_ids: selectedIds,
      email : userDetails?.email
    });
    if (response.status === 200) {
      // fetchVisitors()
      toast.success("Email Sent successfully");
    }
  } catch (error) {
    toast.error("Error deleting visitors");
  } finally {
    setDeleteLoading(false);
    setSelectedIds([]);
  }
};


const toggleSelection = (id) => {
  setSelectedIds((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};

const handleEdit = (item) => {
  setEditItem(item);
  setOpenEditModal(true);
};

const handleEditSave = (updated) => {
  setVisitorsList((prev) =>
    prev.map((item) => (item.pre_register_visitor_id === updated.id ? updated : item))
  );
  setOpenEditModal(false);
};

const handleAddSave = async (newItem) => {
  console.log("newItem", newItem);
  // setVisitorsList((prev) => [...prev, newItem]);
  setModalLoading(true);
  try {
    const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}create_visitor_based_title?creator_email=${userDetails?.email}`,{
      title_id: id,
      invitors : newItem,
      created_by : userDetails?.id,
      role_id : userDetails?.user_role,
      company_id : (userDetails?.user_role == 1 || userDetails?.user_role == 2) ? visitors?.company_id : userDetails?.company_user_id,
      invited_by : userDetails?.id
    });
    if (response.status === 200) {
      // setVisitorsList((prev) => [...prev, response.data]);
      fetchVisitors();
      toast.success("Visitor added successfully");
      setOpenAddModal(false);
      setModalLoading(false);
    }
  } catch (error) {
    console.error("Error adding visitor:", error);
    setModalLoading(false);
  }
 
};

  // useEffect(() => {
  //   axiosInstance
  //     .get(
  //       `${process.env.REACT_APP_API_URL}invite_visitor/property/${propertyId}/invitation/${id}`
  //     )
  //     .then((data) => {
  //       console.log("data", data.data);
  //       const dataa = data?.data?.data?.invitation;
  //       setvisitors(dataa);
  //       // console.log("data", dataa);
  //       setloading(false);

  //       if (dataa?.type_id === 3) {
  //         setblock({ wovisitor: false, wvisitor: false, selfregister: true });
  //       } else {
  //         if (dataa.invited_visitor?.length > 0 && dataa?.type_id === 2) {
  //           setblock({ wovisitor: true, wvisitor: true, selfregister: false });
  //         } else if (
  //           dataa.invited_visitor?.length == 0 &&
  //           dataa?.type_id === 1
  //         ) {
  //           setblock({ wovisitor: true, wvisitor: false, selfregister: false });
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
 

    setblock({
      wovisitor: true,
      wvisitor: true,
      selfregister: false,
    });
}, []);


  return (
    <>
      <ToastContainer />
      <Box p={5} sx={{ backgroundColor: "#F3F4F6" }}>
        <Stack direction="row" justifyContent="space-between">
          <BackArrow
            onClick={() => navigate("/invite_visitor")}
            style={{ marginBottom: "26px", cursor: "pointer" }}
          />
        </Stack>
        {/* <Box mb={5}>
          <PrimaryTypography mb={1}>
            {loading ? <Skeleton width={200} /> : "#" + visitors?.uuid}
          </PrimaryTypography>
        </Box> */}
        {loading ? (
          <Skeleton variant="rounded" width="100%" height="50vh" />
        ) : (
          <>
            {block?.wovisitor && (
              <Box
                mt={3}
                component="div"
                boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
                borderRadius="8px"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  px="16px"
                  sx={{
                    height: "66px",
                    backgroundColor: "#FCFCFD",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px 8px 0 0 ",
                  }}
                >
                  <SecondaryTypography>Invitation Details</SecondaryTypography>
                </Stack>
                <Grid
                  container
                  xs={12}
                  gap="2.8%"
                  sx={{
                    backgroundColor: "white",
                    padding: "30px 16px 30px 16px",
                    border: "1px solid #E5E7EB",
                    borderRadius: "0 0 8px 8px  ",
                  }}
                >
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Purpose of Visit
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.title || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Description
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.description || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Company Name
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.company_Name || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Host Name
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.alias_name || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Level
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.level || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Unit
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.unit || "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Access Start Date
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.valid?.valid_from
                        ? `${moment(visitors?.valid?.valid_from).format(
                            "DD MMM YYYY"
                          )}`
                        : "-"}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Access End Date
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.valid?.valid_to
                        ? `${moment(visitors?.valid?.valid_to).format("DD MMM YYYY")} `
                        : "-"}
                    </TypographyDefault>
                  </Grid>
                  
                  <Divider
                    sx={{
                      borderTop: "1px solid #F3F4F6",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  />
                  

                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Total Visitors
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.visitor_personal_details.length === 0
                        ? "-"
                        : visitors?.visitor_personal_details.length}
                    </TypographyDefault>
                  </Grid>
                  <Grid xs={12} sm={5.8} sx={reviewstyle}>
                    <StyledSecondaryTypography>
                      Invited By
                    </StyledSecondaryTypography>
                    <TypographyDefault>
                      {visitors?.invited_by || "-" }
                    </TypographyDefault>
                  </Grid>
                </Grid>
              </Box>
            )}
            {/* {block.wvisitor && (
              <Box
                mt={3}
                component="div"
                boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
                borderRadius="8px"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  px="16px"
                  sx={{
                    height: "66px",
                    backgroundColor: "#FCFCFD",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px 8px 0 0 ",
                  }}
                >
                  <SecondaryTypography>Visitor Details</SecondaryTypography>
                </Stack>
                <Grid
                  container
                  xs={12}
                  gap="2.8%"
                  sx={{
                    backgroundColor: "white",
                    padding: "30px 16px 30px 16px",
                    border: "1px solid #E5E7EB",
                    borderRadius: "0 0 8px 8px  ",
                  }}
                >
                  {visitors?.invited_visitor
                    ? visitors?.invited_visitor?.map((itm) => {
                        const { name, email, phone } = itm;
                        return (
                          <Grid xs={12} sm={5.8} sx={reviewstyle}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              gap="30px"
                            >
                              <Avatar {...stringAvatar(name)} />
                              <Stack direction="column">
                                <PrimaryTypography>{name}</PrimaryTypography>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    color: "#4D5761",
                                  }}
                                >
                                  {email}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "13px",
                                    fontWeight: "400",
                                    color: "",
                                  }}
                                >
                                  {phone}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Grid>
                        );
                      })
                    : "-"}
                </Grid>
              </Box>
            )} */}

            {block.wvisitor && (
  <Box mt={3} boxShadow="0 0 3px 0 rgba(0,0,0,0.1)" borderRadius="8px">
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px="16px"
      sx={{
        height: "66px",
        backgroundColor: "#FCFCFD",
        border: "1px solid #E5E7EB",
        borderRadius: "8px 8px 0 0 ",
      }}
    >
      <SecondaryTypography>Visitor Details</SecondaryTypography>

      <Stack direction="row" gap={2}>
         <Button variant="outlined" onClick={() => setOpenAddModal(true)}>
          Add Visitor
        </Button>

        <Button
          variant="contained"
          color="error"
          disabled={deleteLoading || selectedIds.length === 0}
          onClick={handleMultiSendEmail}
        >
          Resend Email
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={deleteLoading || selectedIds.length === 0}
          onClick={handleMultiDelete}
        >
          Delete Selected
        </Button>
      </Stack>
    </Stack>

    <Grid
      container
      xs={12}
      gap="2.8%"
      sx={{
        backgroundColor: "white",
        padding: "30px 16px",
        border: "1px solid #E5E7EB",
        borderRadius: "0 0 8px 8px",
      }}
    >
      {visitorsList.length > 0 ? (
        visitorsList.map((itm) => {
          const { pre_register_visitor_id, name, email, phone } = itm;
          return (
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <Stack direction="row" alignItems="flex-start" gap="20px">
                
                {/* Checkbox for multi delete */}
                <Checkbox
                  checked={selectedIds.includes(pre_register_visitor_id)}
                  onChange={() => toggleSelection(pre_register_visitor_id)}
                />

                {/* Avatar + Details */}
                <Stack direction="row" alignItems="center" gap="30px">
                  <Avatar {...stringAvatar(name)} />
                  <Stack>
                    <PrimaryTypography>{name}</PrimaryTypography>
                    <Typography sx={{ fontSize: "16px", color: "#4D5761" }}>
                      {email}
                    </Typography>
                    <Typography sx={{ fontSize: "13px" }}>{formatPhone(phone)}</Typography>
                    <Typography sx={{":hover" : {cursor : 'pointer'}, color : '#800000', textDecoration : "underline"}} disabled={deleteLoading} onClick={() => handleSendEmail(pre_register_visitor_id)}>{"Resend Email"}</Typography>
                  </Stack>
                </Stack>

                {/* Individual edit/delete */}
                <Stack direction="row" gap={1} ml="auto">
                  {/* <IconButton onClick={() => handleEdit(itm)}>
                    <EditIcon />
                  </IconButton> */}
<IconButton  title="Copy Qr Code" onClick={() => copyToClipboard(itm.qr_url)}>
  <ContentCopyIcon fontSize="small" />
</IconButton>
                  <IconButton
  disabled={deleteLoading}
  onClick={() => {
    setDeleteId(pre_register_visitor_id);
    setOpenDeleteModal(true);
  }}
>
  <DeleteIcon />
</IconButton>
                </Stack>
              </Stack>
            </Grid>
          );
        })
      ) : (
        <Typography px={2}>No visitors found.</Typography>
      )}
    </Grid>
  </Box>
)}

            {block.selfregister && (
              <Box
                mt={3}
                component="div"
                boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
                borderRadius="8px"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  px="16px"
                  sx={{
                    height: "66px",
                    backgroundColor: "#FCFCFD",
                    border: "1px solid #E5E7EB",
                    borderRadius: "8px 8px 0 0 ",
                  }}
                >
                  <SecondaryTypography>
                    {" "}
                    Self Registration Details
                  </SecondaryTypography>
                </Stack>
                {visitors?.invited_visitor?.map((value) => (
                  <Grid
                    container
                    xs={12}
                    gap="2.8%"
                    sx={{
                      backgroundColor: "white",
                      padding: "30px 16px 30px 16px",
                      border: "1px solid #E5E7EB",
                      borderRadius: "0 0 8px 8px  ",
                    }}
                  >
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Date & Time
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.start_date && visitors?.end_date
                          ? moment
                              .utc(visitors.start_date)
                              .local()
                              .format("DD MMM YYYY") -
                            moment
                              .utc(visitors.end_date)
                              .local()
                              .format("DD MMM YYYY")
                          : "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Location
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.location
                          ? visitors?.location?.map((result, index) => (
                              <TypographyDefault key={index}>
                                {result ? result : "-"}
                              </TypographyDefault>
                            ))
                          : "-"}
                      </TypographyDefault>
                    </Grid>
                    <Divider
                      sx={{
                        borderTop: "1px solid #F3F4F6",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    />
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Full Name
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {value?.name || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Email Address
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {value?.email || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Divider
                      sx={{
                        borderTop: "1px solid #F3F4F6",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    />
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Residents Unit Number
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {value?.unit_id || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Contact Number
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {" "}
                        {value?.phone || "-"}
                      </TypographyDefault>
                    </Grid>
                    <Divider
                      sx={{
                        borderTop: "1px solid #F3F4F6",
                        width: "100%",
                        marginTop: "10px",
                      }}
                    />

                    <Grid xs={12} sm={5.8} sx={reviewstyle}>
                      <StyledSecondaryTypography>
                        Visitor(s)
                      </StyledSecondaryTypography>
                      <TypographyDefault>
                        {visitors?.total_count === 0
                          ? "-"
                          : visitors?.total_count + " " + "px"}
                      </TypographyDefault>
                    </Grid>
                  </Grid>
                ))}
              </Box>
            )}
          </>
        )}
      </Box>

      <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
  <DialogTitle>Confirm Delete</DialogTitle>

  <DialogContent>
    Are you sure you want to delete this visitor?
  </DialogContent>
  <DialogContent>
    <Grid item xs={12} sm={4}>
                  <Typography>Reason (Optional)</Typography>
    
                  <TextField
                    value={reasonDelete}
                    onChange={(e) => setReasonDelete(e.target.value)}
                    fullWidth
                    inputProps={{ maxLength: 100 }}
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInputBase-root": {
                        color: "#111927",
                      },
                      backgroundColor: "#F9FAFB",
                      mt: 1,
                    }}
                  />
                </Grid>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDeleteModal(false)} disabled={deleteLoading}>
      Cancel
    </Button>

    <Button
      color="error"
      onClick={() => handleDelete(deleteId)}
      disabled={deleteLoading}
    >
      {deleteLoading ? "Deleting..." : "Delete"}
    </Button>
  </DialogActions>
</Dialog>

      <VisitorModal
  open={openEditModal}
  onClose={() => setOpenEditModal(false)}
  initialData={editItem}
  onSave={handleEditSave}
  visitors={visitors}
  parentCount={visitorsList.length}
/>

<VisitorModal
  open={openAddModal}
  onClose={() => setOpenAddModal(false)}
  parentCount={visitorsList.length}
  onSave={handleAddSave}
  visitors={visitors}
  loading={modalLoading}
/>
    </>
  );
};

export default VisitorsDetails;
